import { NavLink } from 'react-router-dom'
import Icon from '@mdi/react'
import styled from 'styled-components'

import theme from 'theme_'
import { CommonLinkButton } from 'components/Button'
import { Font14 } from 'components/Typography'

export const StyledHomeAside = styled.aside<{ $isCollapsed: boolean }>`
  z-index: ${theme.zIndex.homeAside};
  display: flex;
  position: fixed;
  transition: all 0.3s ease;
  left: 0;
  top: ${theme.sizes.headerHeight};
  width: 100%;
  box-shadow: 0 4px 40px ${theme.colors.commonShadow};
  overflow: auto;
  background-color: ${theme.colors.white};
  @media ${theme.devices.tablet} {
    background-color: transparent;
    box-shadow: none;
    overflow: visible;
    left: auto;
    display: block;
    width: ${(p) => (p.$isCollapsed ? '72px' : '256px')};
  }
`

export const StyledAsideMenu = styled.ul`
  display: flex;
  flex-direction: row;
  background-color: ${theme.colors.white};
  box-shadow: 10px 10px 10px rgba(0, 0, 0, 0.01);
  border-radius: 0;
  margin: 0;
  padding: 0;
  overflow: auto;
  max-height: 80vh;
  @media ${theme.devices.tablet} {
    border-radius: 8px;
    flex-direction: column;
  }
`

export const StyledAsideMenuItem = styled.li<{
  selected?: boolean
}>`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 96px;
  height: 64px;
  list-style-type: none;
  padding: 0;
  color: ${(p) =>
    p.selected ? theme.colors.horizonOrange : theme.colors.duneWarmGrey};
  background: ${(p) =>
    p.selected ? theme.colors.activeState : theme.colors.white};
  transition: all 0.2s ease;

  @media ${theme.devices.tablet} {
    flex-direction: row;
    width: auto;
    height: 56px;
    :hover {
      background: ${(p) =>
        p.selected ? theme.colors.activeState : theme.colors.accent10};
      color: ${theme.colors.horizonOrange};
    }
  }
`

export const StyledAsideMenuCollapseItem = styled(StyledAsideMenuItem)`
  box-shadow: inset 0px -1px 0px rgba(0, 0, 0, 0.05);
  justify-content: flex-end;
  display: none;
  @media ${theme.devices.tablet} {
    display: flex;
  }
`

export const StyledAsideMenuLink = styled(NavLink)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 8px;
  text-decoration: none;
  color: inherit;
  transition: all 0.2s ease;
  width: 100%;
  height: 100%;
  @media ${theme.devices.tablet} {
    padding: 16px 24px;
    flex-direction: row;
    justify-content: flex-start;
    align-items: flex-start;
  }
`

export const StyledAsideMenuLinkTitle = styled.span`
  flex: 1;
  text-align: center;
  animation-name: ${theme.animations.fadeIn};
  animation-duration: 0.2s;
  font-weight: 900;
  font-size: 11px;
  line-height: 13px;
  margin-left: 0;
  @media ${theme.devices.tablet} {
    text-align: left;
    white-space: nowrap;
    ${Font14};
    line-height: 24px;
    margin-left: 20px;
  }
`

export const MenuCollapseButton = styled(CommonLinkButton)`
  display: flex;
  align-items: center;
  color: inherit;
  padding: 16px 24px;
  transition: all 0.2s ease;
`
export const StyledAsideMenuIcon = styled(Icon)`
  min-width: 24px;
  margin-bottom: 4px;
  @media ${theme.devices.tablet} {
    margin-bottom: 0;
  }
`

export const MenuCollapseIcon = styled(StyledAsideMenuIcon)`
  transition: all 0.2s ease;
`
